import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Fetch } from '../../utils/Utils.js';

export const FinanceCategoryDropdown = (props) => {
  const { t } = useTranslation();
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    if (props.categories != null) {
      setCategories(props.categories);
      return;
    }
    Fetch('api/data/finance.categories', 'GET', null,
      (data) => setCategories(data || []),
      () => {}
    );
  }, [props.categories]);

  return (
    <select value={props.selected || ''} onChange={props.onChange} style={props.style}>
      {props.showAll && <option value="">{props.allLabel || '—'}</option>}
      {categories.map(cat => (
        <option key={cat._id} value={cat.name}>{t(cat.name, { defaultValue: cat.name })}</option>
      ))}
    </select>
  );
};

export default FinanceCategoryDropdown;
